module.exports = __webpack_public_path__ + "img/like.fdab68b6.png";